import { Injectable, inject } from '@angular/core';
import { iconList } from '../../../../../icons.config';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  private readonly iconList: string[];

  constructor() {
    this.iconList = iconList;
  }

  get icons(): string[] {
    return this.iconList;
  }

  registerIcons(): void {
    this.iconList.forEach(icon => {
      const iconUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${icon}.svg`);
      this.iconRegistry.addSvgIcon(icon, iconUrl);
    });
  }
}
